var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { container } from 'tsyringe';
import { types } from './index';
import { CandidateExportRepository, } from 'packages/candidate_export/CandidateExportRepository';
var repo = container.resolve(CandidateExportRepository);
export var actions = {
    getSubProcessorConsents: function (_a) {
        var commit = _a.commit, rootGetters = _a.rootGetters;
        return __awaiter(this, void 0, void 0, function () {
            var _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        commit(types.SET_LOADING, true);
                        _b = commit;
                        _c = [types.SET_CONSENTS];
                        return [4 /*yield*/, repo.getConsents(rootGetters.currentCompanyId)];
                    case 1:
                        _b.apply(void 0, _c.concat([_d.sent()]));
                        commit(types.SET_LOADING, false);
                        return [2 /*return*/];
                }
            });
        });
    },
    storeKomboSubProcessorConsent: function (_a, consent) {
        var commit = _a.commit, state = _a.state, rootGetters = _a.rootGetters;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        commit(types.SET_LOADING, true);
                        return [4 /*yield*/, repo.storeConsent(rootGetters.currentCompanyId, consent)];
                    case 1:
                        _b.sent();
                        commit(types.SET_CONSENTS, __spreadArray(__spreadArray([], state.consents), [consent]));
                        commit(types.SET_LOADING, false);
                        return [2 /*return*/];
                }
            });
        });
    },
    getExportSystemsForCurrentCompany: function (_a) {
        var commit = _a.commit, rootGetters = _a.rootGetters;
        return __awaiter(this, void 0, void 0, function () {
            var _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        commit(types.SET_LOADING, true);
                        _b = commit;
                        _c = [types.SET_EXPORT_SYSTEMS];
                        return [4 /*yield*/, repo.listIntegrationSystems(rootGetters.currentCompanyId)];
                    case 1:
                        _b.apply(void 0, _c.concat([_d.sent()]));
                        commit(types.SET_LOADING, false);
                        return [2 /*return*/];
                }
            });
        });
    },
    getExportJobsForSystem: function (_a, payload) {
        var _b;
        var commit = _a.commit, state = _a.state, rootGetters = _a.rootGetters;
        return __awaiter(this, void 0, void 0, function () {
            var fetchPayload, _c, jobs, nextCursor;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        commit(types.SET_LOADING, true);
                        switch (payload.paginationAction) {
                            case 'reset':
                                commit(types.RESET_EXPORT_JOBS_PAGINATION);
                                break;
                            case 'next':
                                if (!state.exportJobsPagination.canGoNext) {
                                    commit(types.SET_LOADING, false);
                                    return [2 /*return*/];
                                }
                                commit(types.SET_EXPORT_JOBS_PAGINATION_CURSOR_STACK, __spreadArray(__spreadArray([], state.exportJobsPagination.cursorStack), [state.exportJobsPagination.nextCursor]));
                                break;
                            case 'back':
                                if (!state.exportJobsPagination.canGoBack) {
                                    commit(types.SET_LOADING, false);
                                    return [2 /*return*/];
                                }
                                commit(types.SET_EXPORT_JOBS_PAGINATION_CURSOR_STACK, __spreadArray([], state.exportJobsPagination.cursorStack.slice(0, -1)));
                                commit(types.SET_EXPORT_JOBS_PAGINATION_NEXT_CURSOR, state.exportJobsPagination.cursorStack[state.exportJobsPagination.cursorStack.length - 1]);
                                break;
                        }
                        fetchPayload = {
                            params: {
                                companyId: rootGetters.currentCompanyId,
                                toolId: payload.toolId,
                            },
                            query: {
                                pageSize: (_b = payload.pageSize) !== null && _b !== void 0 ? _b : state.exportJobsPagination.pageSize,
                                cursor: state.exportJobsPagination.nextCursor,
                                statuses: payload.statuses,
                                nameContains: payload.nameContains,
                            },
                        };
                        return [4 /*yield*/, repo.listJobs(fetchPayload)];
                    case 1:
                        _c = _d.sent(), jobs = _c.jobs, nextCursor = _c.nextCursor;
                        commit(types.SET_EXPORT_JOBS, jobs);
                        commit(types.SET_EXPORT_JOBS_PAGINATION_NEXT_CURSOR, nextCursor);
                        commit(types.SET_LOADING, false);
                        return [2 /*return*/];
                }
            });
        });
    },
    exportCandidates: function (_a, payload) {
        var commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        commit(types.SET_LOADING, true);
                        return [4 /*yield*/, repo.exportCandidates(payload)];
                    case 1:
                        _b.sent();
                        commit(types.SET_LOADING, false);
                        return [2 /*return*/];
                }
            });
        });
    },
};
